import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatCheckbox } from '@angular/material';

@Component({
  selector: 'app-patient-consent-to-draw',
  templateUrl: './patient-consent-to-draw.component.html',
  styleUrls: ['./patient-consent-to-draw.component.scss']
})
export class PatientConsentToDrawComponent implements OnInit {

  isSelectedSystemSelfTesting: boolean;
  today = new Date();
  consentFormControl: FormControl;
  @Input() firstName: string;
  @Input() middleName: string;
  @Input() lastName: string;
  @Output() checkConsetToDraw : EventEmitter<boolean> = new EventEmitter();
  checked: boolean = false;
  constructor() {
    this.consentFormControl = new FormControl(false, Validators.requiredTrue);
  }

  ngOnInit() {
  }

  doCheckConsetToDraw($event:MatCheckbox) {
    this.checkConsetToDraw.emit($event.checked);
    this.checked = $event.checked;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/patient-consent-to-draw/patient-consent-to-draw.component.ts